import React from 'react';

export function EditPencil () {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill="#071C3E"
                d="M5.15 13.867l.145.478.12-.036.089-.089-.354-.353zM2.133 10.85l-.353-.354-.09.089-.035.12.478.145zm-1.3 4.318l-.48-.144a.5.5 0 00.623.623l-.144-.48zm13.67-10.654l.354.354-.354-.354zm-9.497 8.874L.688 14.689l.288.958 4.319-1.302-.289-.957zm-3.695 1.924l1.301-4.318-.957-.289-1.302 4.319.958.288zm4.193-1.799l-3.017-3.017-.707.707 3.017 3.017.707-.707zm-3.017-2.31l9.353-9.352-.707-.707-9.353 9.352.707.707zm9.353-9.352l.221-.221-.707-.708-.221.222.707.707zm2.531 2.088l-.221.222.707.707.221-.221-.707-.708zm-.221.222l-9.353 9.352.707.707 9.353-9.352-.707-.707zm-3.017-2.31l3.017 3.017.707-.707-3.017-3.017-.707.707zm3.238-.221a1.633 1.633 0 010 2.31l.707.707a2.633 2.633 0 000-3.724l-.707.707zm.707-.707a2.633 2.633 0 00-3.724 0l.707.707a1.633 1.633 0 012.31 0l.707-.707z"
            />
        </svg>
    );
}
